import React, { useEffect, useState } from "react";
import logo from "../../../assets/Logo/FBX_2024_alone.svg";
import "./supportAnnouncement.style.scss";

const STORAGE_KEY = "FBX_HIDE_WHITE_BOARD_WELCOME";

const WhiteBoardAnnouncement = ({ show = false }) => {
    const [visible, setVisible] = useState(false);

    useEffect(() => {
        if (!show) {
            setVisible(false);
            return;
        }

        try {
            setVisible(localStorage.getItem(STORAGE_KEY) !== "Yes");
        } catch {
            setVisible(true);
        }
    }, [show]);

    const dismissThisTime = () => {
        setVisible(false);
    };

    const dismissForGood = () => {
        try {
            localStorage.setItem(STORAGE_KEY, "Yes");
        } catch {}
        setVisible(false);
    };

    if (!visible) return null;

    return (
        <div className="support-announcement-backdrop white-board-announcement-backdrop" role="dialog" aria-modal="true">
            <div className="support-announcement white-board-announcement">
                <div className="support-announcement__brand white-board-announcement__brand">
                    <img src={logo} alt="FBX" />
                    <div>
                        <h2>Welcome to White Board</h2>
                    </div>
                </div>

                <div className="support-announcement__body white-board-announcement__body">
                    <div className="white-board-announcement__button-preview">
                        <span>White Board</span>
                    </div>

                    <div className="support-announcement__copy">
                        <p>
                            White Board is the new tab up top. Use it to build and save board
                            layouts with players, headings, pages, priority lists, notes, and presets.
                        </p>
                        <p>
                            Follow the <strong>Tutorial</strong> inside White Board for a
                            step-by-step guide on how to use it.
                        </p>
                    </div>
                </div>

                <div className="support-announcement__actions">
                    <button type="button" className="btn btn-outline-secondary" onClick={dismissThisTime}>
                        Dismiss This Time
                    </button>
                    <button type="button" className="btn btn-primary" onClick={dismissForGood}>
                        Dismiss for All Time
                    </button>
                </div>
            </div>
        </div>
    );
};

export default WhiteBoardAnnouncement;
